module.exports = __webpack_public_path__ + "static/media/boxSkillIcon.16932719.svg";